import { ResolvedProject, Project } from './types';
import theOffice from './the-office/project';
import bajaLinkResort from './baja-link-resort/project';
import neptunoResidential from './neptuno-residential/project';
import maraicaBay from './maraica-bay/project';
import puertaCortes from './puerta-cortes/project';
import casaTerracota from './casa-terracota/project';
import cardioEssenceCenter from './cardio-essence-center/project';
import suspendedHorizon from './suspended-horizon/project';
import { getCoverUrl, sortByNumericSuffix } from '@/lib/assets';

const rawProjects: Project[] = [
  theOffice,
  bajaLinkResort,
  neptunoResidential,
  maraicaBay,
  puertaCortes,
  casaTerracota,
  cardioEssenceCenter,
  suspendedHorizon,
];

const resolveProjectAssets = (project: Project): ResolvedProject => {
  const id = project.info.id;
  const sortedImages = sortByNumericSuffix(project.assets.images.map((i) => i.file));
  const sortedPanos = sortByNumericSuffix(project.assets.panos.map((p) => p.file));
  const sortedVideos = sortByNumericSuffix(project.assets.videos.map((v) => v.file));

  const imageUrl = (file: string, ext = 'webp') => `/images/${file}.${ext}`;
  const videoUrl = (file: string, ext = 'mp4') => `/images/${file}.${ext}`;
  const panoUrl = (file: string, ext = 'webp') => `/images/${file}.${ext}`;

  return {
    ...project,
    info: {
      ...project.info,
      cover: project.info.cover || getCoverUrl(id),
    },
    assets: {
      images: sortedImages.map((file) => ({
        file,
        ext: 'webp',
        url: imageUrl(file),
      })),
      videos: sortedVideos.map((file) => {
        const original = project.assets.videos.find((v) => v.file === file);
        const ext = original?.ext || 'mp4';
        const poster = original?.poster;
        return {
          file,
          ext,
          poster,
          url: videoUrl(file, ext),
        };
      }),
      panos: sortedPanos.map((file) => ({
        file,
        ext: 'webp',
        url: panoUrl(file),
      })),
    },
  };
};

export const projects: ResolvedProject[] = rawProjects.map(resolveProjectAssets);

export const getProjectBySlug = (slug: string) => projects.find((project) => project.slug === slug);

export const getProjects = () => projects;

export { toLegacyProject } from './legacy';
export type { LegacyProjectData } from './legacy';
export type { ResolvedProject } from './types';
